<template>
	<div>
		<div class="inputList">

			<labelInput :outInput="newform.company_name" :spanRequired="true" normalPlace="请输入单位名称"
						@inputChange="labelInput($event,'company_name')"
						spanTitle="单位名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.engineering" :spanRequired="true" normalPlace="请输入工程名称（请按合同填写）"
						@inputChange="labelInput($event,'engineering')"
						spanTitle="工程名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.project_name" :spanRequired="true" normalPlace="请输入项目名称(如某项目经理部)"
			@inputChange="labelInput($event,'project_name')"
				spanTitle="项目部名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.contacts" :spanRequired="true" normalPlace="请输入联系人"
			@inputChange="labelInput($event,'contacts')"
				spanTitle="联系人" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入联系电话"
			@inputChange="labelInput($event,'contacts_phone')"
				:isPhone="true" specilType='number' :maxLimit="11" spanTitle="联系电话" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>

			<labelInput :outInput="newform.achievement_name" :spanRequired="true" normalPlace="请输入成果题目"
			@inputChange="labelInput($event,'achievement_name')"
				spanTitle="论文题目" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>

			<normalSelect :outInput="newform.headcount" :spanRequired="true" @selectCode="labelInput($event,'headcount')" :spanWidth="spanWidth"
						  :dataList="dataList2" componentWidth="520px" spanTitle="编制人数">
			</normalSelect>


		<!--	<labelInput :outInput="newform.headcount" :spanRequired="true" normalPlace="请输入编制人数"
			@inputChange="labelInput($event,'headcount')"
				spanTitle="编制人数" specilType='number' :maxLimit="11" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>-->

			<labelInput :outInput="newform.author" :spanRequired="true" normalPlace="请输入编制人姓名(不超过6人并自行排序,以逗号分隔)" specilType="textarea"
				@inputChange="labelInput($event,'author')" :maxLimit="999" spanTitle="编制人姓名" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
		</div>
	</div>
</template>

<script>
	import labelInput from '../../../components/table/labelInput.vue'
	import normalSelect from '../../../components/table/normalSelect.vue'

	export default {
		data() {
			return {
				spanWidth: '180px',
				newform:{},
				form: {
					project_name: '',
					company_name: '',
					contacts: '',
					contacts_phone: '',
					achievement_name: '',
					headcount: '',
					engineering: '',
					author: ''
				},

				dataList2: [
					[{
						name: '1',
						code: '1'
					}, {
						name: '2',
						code: '2'
					},
						{
							name: '3',
							code: '3'
						},
						{
							name: '4',
							code: '4'
						},
						{
							name: '5',
							code: '5'
						},
						{
							name: '6',
							code: '6'
						}
					]
				],

			}
		},
		components: {
			labelInput,
			normalSelect
		},
		props: {
			basicMsg: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		watch: {
			basicMsg(newvalue) {
				this.newform = {
					...newvalue
				}
			},
		},
		created() {
			this.$emit('basicInfo', this.form)
		},
		methods: {
			labelInput(e, name) {
				this.form[name] = e
				this.$emit('basicInfo', this.form)
			},
		}
	}
</script>

<style scoped>
	.midflex {
		width: 100%;
		text-align: center;
		margin-bottom: 20px;
	}

	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.titleLeft {
		margin-left: 50px;
	}

	.awardInfo {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}
</style>
